
export default {
  name: 'Form',
  data() {
    return {
      showResult: false,
      searchValue: null,
    };
  },
  created() {
    this.$nuxt.$on('active-results-list', () => {
      this.showResult = true;
    });
  },
  beforeDestroy() {
    this.$nuxt.$off('active-results-list', () => {
      this.showResult = true;
    });
  },
  methods: {
    search(value) {
      this.searchValue = value;
      this.$nuxt.$emit('calculate-display-route', { search: value });
    },
    change() {
      this.showResult = false;
    },
  },
};
